import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  CircularProgress,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import CustomRankingInput from "../../components/formComponent/CustomRankingInput";
import { addRanking, editRanking } from "../../services/rankingsApi";
import moment from "moment";
import CustomSelect from "../../components/formComponent/CustomSelect";
import { updateOnlineLead } from "../../services/newdashboard";
import { toast } from "react-toastify";

// Parse date to get month and year
const parseDate = (date: string) => {
  const parsedDate = moment(date);
  return {
    month: parsedDate.month() + 1, // moment months are 0-based
    year: parsedDate.year(),
  };
};

type UpdateOnlineLeadsProps = {
  open: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  clinicData: any;
  dateFilter: {
    startDate: string;
    endDate: string;
  };
  mode?: any;
  initialData?: any;
  refetchApi?: () => void;
};

type RankingFormData = {
  notes: string;
  status: string;
};

const UpdateOnlineLeads: React.FC<UpdateOnlineLeadsProps> = ({
  open,
  onClose,
  onSave,
  clinicData,
  dateFilter,
  mode = "edit",
  initialData,
  refetchApi,
}) => {
  const { handleSubmit, control, reset, getValues, watch } = useForm<any>({
    defaultValues: {
      notes: "",
      status: "",
    },
  });

  useEffect(() => {
    if (mode === "edit" && initialData) {
      reset({
        notes: initialData.notes ?? "",
        status: initialData.newStatus ?? "",
      });
    }
  }, [initialData, mode, reset]);

  const allValues = getValues();
  const [isLoading, setIsLoading] = useState(false);
  const handleSave = async (data: any) => {
    setIsLoading(true);
    const payload = {
      notes: data.notes,
      status: data.status,
    };
    let response;
    if (mode == "edit") {
      response = await updateOnlineLead(
        payload,
        clinicData?.uniqueId,
        initialData.id
      );
    }

    if (response?.status?.msg === "Success") {
      toast.success("Online Lead updated successfully");
      onSave(data);
      onClose();
      reset();
      setIsLoading(false);
      refetchApi?.();
    } else {
      setIsLoading(false);
      onClose();
    }
  };

  const handleClose = () => {
    onClose();
    reset(); // Reset the form when closing
  };

  console.log(initialData, "initialData");

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={true}
      maxWidth="sm"
      PaperProps={{
        style: { borderRadius: "10px" },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "#194e5b",
          color: "white",
          borderTopLeftRadius: "10px",
          borderTopRightRadius: "10px",
        }}
      >
        Update Online Lead
      </DialogTitle>
      <DialogContent sx={{ marginTop: "10px" }}>
        <Controller
          name="notes"
          control={control}
          rules={{ required: false }}
          render={({
            field: { onChange, onBlur, value, name, ref },
            fieldState,
          }) => (
            <CustomRankingInput
              name="notes"
              label="Notes"
              placeholder="Enter notes"
              field={{ onChange, onBlur, value, name, ref }}
              fieldState={fieldState}
            />
          )}
        />
        <div className="px-6" style={{ paddingLeft: 0, paddingRight: 0 }}>
          <CustomSelect
            name="status"
            control={control}
            label="Status"
            rules={{
              required:
                watch("status") === "select" && watch("notes") !== ""
                  ? true
                  : watch("status") !== "select" && watch("notes") === ""
                  ? true
                  : false,
            }}
            options={[
              { value: "select", label: "Select" },
              { value: "Opportunity Lost", label: "Opportunity Lost" },
              { value: "Acquisition", label: "Acquisition" },
              { value: "Existing", label: "Existing" },
            ]}
            className="w-full"
          />
        </div>
      </DialogContent>
      <DialogActions>
        <button
          onClick={handleClose}
          className="btn btn-sm"
          style={{ backgroundColor: "#c9eeeb", color: "#0E3843" }}
        >
          Cancel
        </button>
        <button
          onClick={handleSubmit(handleSave)}
          style={{ backgroundColor: "#0E3843" }}
          className="btn btn-sm bg-[#0E3843] min-w-[120px] rounded-md text-white border hover:bg-[#0A2A30]"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress size={20} color="inherit" />
          ) : mode === "edit" ? (
            "Update Online Lead"
          ) : (
            "Save Online Lead"
          )}
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateOnlineLeads;
